import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import InfiniteList from '../infinite-list';
import NotificationListItem from '../notification-list-item';
import { HorizontalSeparator } from '../../components/separator';
import withCardBorderWidth from '../../hoc/with-card-border-width';
import styles from './notification-list.scss';

const THRESHOLD = 400;

const NotificationList = ({ notifications, onItemClick, borderWidth }) =>
  <div
    className={classNames(
      styles.container,
      'forum-card-background-color',
      'forum-card-border-color',
      'forum-text-color'
    )}
    style={{ borderWidth }}
  >
    <InfiniteList
      length={notifications.length}
      itemRenderer={itemRenderer(notifications, onItemClick)}
      threshold={THRESHOLD}
    />
  </div>;

function itemRenderer(notifications, onItemClick) {
  return index =>
    <div className={styles.listItem} key={notifications[index]._id}>
      <NotificationListItem notification={notifications[index]} onClick={onItemClick}/>
      <HorizontalSeparator/>
    </div>;
}

NotificationList.propTypes = {
  notifications: PropTypes.array.isRequired,
  borderWidth: PropTypes.number.isRequired,
  onItemClick: PropTypes.func.isRequired,
};

export default withCardBorderWidth(NotificationList);



// WEBPACK FOOTER //
// ./app/components/notification-list/notification-list.js